module.exports = __webpack_public_path__ + "img/3.768ffe84.png";